/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <b-pagination
    :total-rows="total"
    :per-page="size"
    v-model="currentPage"
    align="center"
    class="bcm-pagination"
    @change="change"
  />
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      required: true
    },
    size: {
      type: Number,
      required: true
    },
    start: {
      type: Number,
      required: true
    }
  },
  computed: {
    currentPage: {
      get () {
        return Math.floor(this.start / this.size) + 1
      },
      set (newPage) {
        /* let newOffset = (newPage - 1) * this.size
        if (newOffset !== this.start) {
          this.$emit('changePage', newOffset)
        } */
      }
    }
  },
  methods: {
    change (newPage) {
      let newOffset = (newPage - 1) * this.size
      if (newOffset !== this.start) {
        this.$emit('changePage', newOffset)
      }
    }
  }
}
</script>
<style lang="scss">
</style>
